// extracted by mini-css-extract-plugin
export default {"badge":"styles__badge___d465t"};